// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { checkoutStepperStyles } from "@steiner/App/Widgets/CheckoutStepper/CheckoutStepper";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

checkoutStepperStyles.stepperWrapper = {
    css: css`
        max-width: 396px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > li[role="listitem"]:last-child {
            .stepper-icon:before {
                display: none;
            }
        }

        ${xScreen("lte", "xs")} {
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 8px;
        }

        ${hideElementOnPrint}
    `,
};

checkoutStepperStyles.stepperItem = {
    wrapper: {
        css: css`
            position: relative;
            flex: 1;
            ${xScreen("lte", "xs")} {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 8px;
            }
        `,
    },
    insideWrapper: {
        css: css`
            ${xScreen("lte", "xs")} {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 8px;
            }
        `,
    },
    icon: {
        css: css`
            width: 15px;
            height: 15px;
            outline: 1px solid ${color("common.ui8")};
            border-radius: 50%;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:before {
                content: "";
                position: absolute;
                background: ${color("common.border")};
                width: calc(100% - 15px);
                left: 15px;
                top: 7px;
                height: 1px;
            }

            & > ${IconWrapper} {
                display: flex;
            }

            ${xScreen("lte", "xs")} {
                margin-bottom: 0;
                &:before {
                    display: none;
                }
            }

            &.active {
                cursor: default;
            }
            &.completed {
                cursor: pointer;
            }
            &.not-clickable {
                cursor: not-allowed;
            }
        `,
    },
    title: {
        color: "text",
        size: 14,
        weight: "normal",
        lineHeight: "18px",
        css: css`
            transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;

            &.active {
                cursor: default;
            }
            &.clickable {
                cursor: pointer;
                font-weight: ${fontConfig.weight.semiBold};
                color: ${color("common.ui8")};
                &:hover {
                    color: ${color("common.ui9")};
                }
            }
            &.not-clickable {
                cursor: not-allowed;
            }
        `,
    },
};
